import { Vue, prop, setup } from 'vue-class-component';
import { Skeleton } from '@/components/skeleton/component';
import { Loader } from '@/components/loader';
import { Icon, IconNames } from '@/components/icon';
import { Input } from '@/components/fields/input';
import { Watch } from 'vue-property-decorator';
import { FormFields, useFormValidation, validatorRequired } from '@/components/fields/validation';
import clsx from 'clsx';
import styles from './styles.module.scss';

class WidgetWrapperProps {
	title = prop<unknown>({ default: undefined })

	value = prop<unknown>({ default: undefined })

	active = prop<boolean>({ default: true })

	loading = prop<boolean>({ default: false })

	image = prop<string>({ default: undefined })

	editIcon = prop<boolean>({ default: false })

	unFormattedValue = prop<number>({ default: 0 })

	onChange = prop<Function>({ default: () => () => undefined })

	inputPrefix = prop<string>({ default: undefined })

	min = prop<number>({ default: 0 })

	max = prop<number>({ default: 1000 })

	isScoreUpdated = prop<boolean>({ default: false })
}

export class WidgetWrapper extends Vue.with(WidgetWrapperProps) {
	form: FormFields = {
		validated: false,
		fields: {
			originalValue: {
				value: 0,
				validators: [],
			},
		},
		validators: {
			required: validatorRequired(),
		},
	};

	formValidation = setup(() => useFormValidation(this.form));

	editMode = false;

	handleSliderValueChange() {
		if (this.form.fields.originalValue.value && this.formValidation.formValid) {
			this.onChange(+this.form.fields.originalValue.value);
		}
	}

	openInput() {
		this.form.fields.originalValue.validators = ['required', 'numeric', `between:${this.min},${this.max}`];
		this.form.fields.originalValue.value = this.unFormattedValue;
		this.editMode = true;
	}

	@Watch('unFormattedValue')
	valueChanged() {
		this.form.fields.originalValue.value = this.unFormattedValue;
		this.closeInput();
	}

	closeInput() {
		if (this.formValidation.formValid) {
			this.editMode = false;
			this.handleSliderValueChange();
		}
	}

	render() {
		return (
			<div class={ clsx([
				styles.widgetWrapper,
				!this.active && styles.widgetWrapperInactive,
			]) }>
				<Loader show={ this.loading } />
				{ this.image && <img class={ styles.widgetWrapperImage } src={ this.image } /> }
				{ this.$slots.icon && this.$slots.icon() }
				<div class={ styles.widgetWrapperTitle }>
					{ this.title || <Skeleton style={ '--skeleton-height: 2em' }/> }
				</div>
				{ this.value && !this.isScoreUpdated && <div class={ styles.widgetWrapperValue }>
					{ !this.editMode && this.value }
					{ this.editIcon && !this.editMode && <span onClick={this.openInput}><Icon class={ styles.widgetWrapperIcon }
						name={ IconNames.pencil } size={ 25 }/> </span> }
				</div> }
				{ this.editIcon && this.editMode && !this.isScoreUpdated && <div class={ styles.widgetWrapperValue }>
					<Input
						onBlur = { this.closeInput }
						type="text"
						v-model={ this.form.fields.originalValue.value }
						prefix={this.inputPrefix}
						mask={'#*'}
						error={ this.formValidation.getError('originalValue') }
					/>
				</div> }
				<div class={ styles.widgetWrapperContent }>
					{ this.$slots.default && this.$slots.default() }
				</div>
			</div>
		);
	}
}
